import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Ativacao from "./pages/Ativacao";
import Onboarding from "./pages/Onboarding";
import OnboardingComplete from "./pages/OnboardingComplete";
import PrivateRoute from "./PrivateRoute";

const Routes = () => {
  useEffect(() => {
    let companyURL = "tupinamba";
    localStorage.setItem("companyURL", companyURL);
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Login} />
        <PrivateRoute path="/ativacao" component={Ativacao} />
        <Route path="/onboarding" exact component={Onboarding} />
        <Route
          path="/onboarding-complete"
          exact
          component={OnboardingComplete}
        />
        <PrivateRoute path="/dashboard" component={Dashboard} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
